<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <div class="md-layout" v-if="serie">
        <div class="md-layout-item md-size-100"></div>
        <div class="md-layout-item md-size-100">
          <SeriesDetail :serie="serie" @addTemplate="addTemplate" @addAssignment="addAssignment">
            <div slot="breadcrumb" class="breadcrumbs">
              <router-link to="/admin/series">
                <small>Series</small>
              </router-link>
              <span class="spacer" />
              <small>
                <b>{{ serie.title }}</b>
              </small>
            </div>
          </SeriesDetail>
        </div>
      </div>
      <div class="md-layout" v-else>
        <div class="md-layout-item">
          <md-progress-spinner :md-diameter="100" :md-stroke="10" md-mode="indeterminate"></md-progress-spinner>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SeriesDetail from "@/components/SeriesDetail.vue";
import { mapState, mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import {
  required,
  email,
  minLength,
  maxLength
} from "vuelidate/lib/validators";

export default {
  name: "AdminSeriesDetails",
  props: {
    id: String
  },
  mixins: [validationMixin],
  components: {
    SeriesDetail
  },
  data: function() {
    return {};
  },
  validations: {},
  methods: {
    ...mapActions({
      getSerieById: "getSerieById",
      addSeriesMessageTemplate: "createMessageTemplate",
      addSeriesAssignment: "createAssignment"
    }),
    addTemplate: function(m) {
      this.addSeriesMessageTemplate({ series_id: this.serie.series_id, template: m });
    },
    addAssignment: function(m) {
      this.addSeriesAssignment({
        series_id: this.serie.series_id,
        assignment: m
      });
    }
  },
  computed: {
    ...mapState({
      serie: s => s.notification.serie
    })
  },
  created: function() {
    this.getSerieById(this.id);
  }
};
</script>
<style>
.breadcrumbs a {
  color: white !important;
}
.breadcrumbs .spacer:before {
  content: " / ";
}
.breadcrumbs {
  margin-bottom: 7px;
}
</style>
